/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * Synthflow Backend
 * OpenAPI spec version: 1.0
 */

export type AIModelTypeName =
  (typeof AIModelTypeName)[keyof typeof AIModelTypeName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AIModelTypeName = {
  synthflow: "synthflow",
  "gpt-4o": "gpt-4o",
  "gpt-41": "gpt-4.1",
  "gpt-41-Mini": "gpt-4.1-Mini",
  "gpt-4o-mini": "gpt-4o-mini",
  "gpt-45": "gpt-4.5",
} as const;
